import React, {CSSProperties, FunctionComponent} from "react";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import {makeStyles, useTheme} from "@material-ui/core";
import Text from "./Text";
import {I18n} from "aws-amplify";

const useStyles = makeStyles(theme => ({
    button: {
        borderRadius: theme.shape.borderRadius,
        padding: 0,
        width: 224
    },
    container: {
        borderRadius: theme.shape.borderRadius,
        borderColor: "transparent",
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        flex: 1,
        maxWidth: 224,
        height: 32
    },
    text: {
        alignSelf: "center"
    }
}));

interface NextButtonProps {
    text?: string;
    onClick?: () => void;
    disabled?: boolean;
    style?: CSSProperties;
}

const NextButton: FunctionComponent<NextButtonProps> = ({text = I18n.get("common").next, style, onClick, disabled}) => {
    const classes = useStyles();
    const theme = useTheme();

    const _onClick = () => {
        if (onClick) {
            onClick();
        }
    };

    return (
        <Button
            className={classes.button}
            style={style}
            onClick={_onClick}
            disabled={disabled}
            type={"submit"}
        >
            <Box
                className={classes.container}
                style={{background: disabled ? theme.palette.secondary.light : "#4CC0C7"}}
            >
                {disabled &&
                <div style={{position: "absolute", background: "rgba(255, 255, 255, 0.7)"}}/>}
                <Text value={text} size={14} color={"#fff"}/>
            </Box>
        </Button>
    );
};

export default NextButton;
